import React, { useState } from "react";
import axios from "axios";
import { CheckCheck, CheckCircle2, Loader2, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BulkApproveBar = ({ headers, toast, pendingIds, selected, clearSelected, onDone }) => {
  const [busy, setBusy] = useState("");
  const selectedPending = selected.filter((id) => pendingIds.includes(id));
  if (!pendingIds.length && !selected.length) return null;

  const approve = async (ids, kind) => {
    if (kind === "all" && !window.confirm(`Listedeki ${ids.length} beklemedeki firma onaylanıp sitede yayınlanacak. Emin misiniz?`)) return;
    setBusy(kind);
    try {
      const r = await axios.post(`${API}/admin/firms/bulk-status`, { ids, status: "approved" }, { headers });
      toast({ title: "Firmalar onaylandı", description: `${r.data.updated} firma sitede yayında.` });
      clearSelected();
      onDone();
    } catch (e) {
      toast({ title: "Hata", description: e?.response?.data?.detail || "Onaylanamadı." });
    }
    setBusy("");
  };

  return (
    <div className="bg-[#FFF8EC] border border-[#F1DDB4] rounded-2xl p-4 flex flex-wrap items-center gap-3" data-testid="bulk-approve-bar">
      <p className="text-sm text-[#6b5530] mr-auto">
        Listede <b data-testid="bulk-pending-count">{pendingIds.length}</b> beklemedeki firma var
        {selected.length > 0 && <> · <b data-testid="bulk-selected-count">{selected.length}</b> seçili</>}
      </p>
      {selected.length > 0 && (
        <button onClick={clearSelected} data-testid="bulk-clear-btn" className="inline-flex items-center gap-1 px-3 h-9 rounded-xl text-sm text-[#7C6E70] hover:bg-white transition-colors">
          <X className="w-4 h-4" /> Seçimi Temizle
        </button>
      )}
      <button onClick={() => approve(selectedPending, "selected")} disabled={!selectedPending.length || !!busy} data-testid="bulk-approve-selected-btn"
        className="inline-flex items-center gap-2 px-4 h-9 rounded-xl border border-[#3F8F5A] text-[#2F7347] text-sm font-medium hover:bg-white transition-colors disabled:opacity-40">
        {busy === "selected" ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />} Seçilenleri Onayla ({selectedPending.length})
      </button>
      <button onClick={() => approve(pendingIds, "all")} disabled={!pendingIds.length || !!busy} data-testid="bulk-approve-all-btn"
        className="inline-flex items-center gap-2 px-4 h-9 rounded-xl bg-[#3F8F5A] text-white text-sm font-medium hover:bg-[#357a4c] transition-colors disabled:opacity-40">
        {busy === "all" ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCheck className="w-4 h-4" />} Tüm Beklemedekileri Onayla ({pendingIds.length})
      </button>
    </div>
  );
};
